import { makeStyles } from "@material-ui/core";
import { white, accentUltraLight } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  summaryModal: {
    position: "absolute",
    boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
    borderRadius: "42px",
    overflow: "hidden",
    left: "10px",
    bottom: "calc(100% + 10px)",
    minWidth: "420px",
    [down("xs")]: {
      minWidth: "auto",
      width: "100%",
      left: 0,
      bottom: "calc(100% - 2px)",
      borderRadius: "20px",
      boxShadow: "0px 3px 34px rgba(0, 0, 0, 0.35)",
    },
  },
  descriptionEl: {
    marginBottom: "16px",
    "& p": {
      fontSize: "14px",
    },
  },
  totalSummary: {
    backgroundColor: white,
    padding: "25px 30px 15px 30px",
  },
  mainSummary: {
    backgroundColor: accentUltraLight,
    padding: "40px 30px 10px 30px",
  },
}));

export default useStyles;
